import { BookmarkSimple } from "@phosphor-icons/react";
import { useFavorites } from "../context/FavoritesContext";

/**
 * Bookmark toggle for an audio or scenepack.
 * variant "pill" = bordered button matching the card like buttons,
 * "large" = full-size secondary button for detail pages.
 */
export default function BookmarkButton({ kind, id, variant = "pill", testId }) {
  const { isFavorite, toggleFavorite } = useFavorites();
  const on = isFavorite(kind, id);
  const onClick = (e) => { e.preventDefault(); e.stopPropagation(); toggleFavorite(kind, id); };
  const label = on ? "Remove from favourites" : "Add to favourites";

  if (variant === "large") {
    return (
      <button
        type="button"
        onClick={onClick}
        title={label}
        data-testid={testId}
        className={`btn-secondary ${on ? "!border-[#880015] !text-[#FF8090]" : ""}`}
      >
        <BookmarkSimple size={16} weight={on ? "fill" : "regular"} /> {on ? "Saved" : "Save"}
      </button>
    );
  }
  return (
    <button
      type="button"
      onClick={onClick}
      title={label}
      aria-pressed={on}
      data-testid={testId}
      className={`flex items-center justify-center p-1.5 rounded-lg border transition ${
        on ? "border-[#880015] bg-[#880015]/20 text-[#FF8090]" : "border-white/10 text-white/60 hover:border-white/30 hover:text-white"
      }`}
    >
      <BookmarkSimple size={13} weight={on ? "fill" : "regular"} />
    </button>
  );
}
